export default __webpack_public_path__ + "assets/images/image-archive.png";